export default "__VITE_ASSET__DctqasJW__"